<template>
	<div class="col-6">
		<div class="d-flex justify-content-between align-items-center">
			<h3 class="mb-0 font-20">Addresses</h3>
			<button class="btn btn-secondary" @click="addAddress">Add Address</button>
		</div>
		<table
			class="table"
			v-if="addresses && addresses.length > 0 && !loading"
		>
			<thead>
				<tr>
					<th scope="col">Country</th>
					<th scope="col">City</th>
					<th scope="col">Address</th>
					<th scope="col">ZIP</th>
					<th scope="col">Company</th>
					<th scope="col">VAT</th>
					<th scope="col" class="text-right mr-5">Status</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="address in addresses" :key="address.id">
					<td>{{address.addressCountry}}</td>
					<td>{{address.addressCity}}</td>
					<td>{{address.addressLine1}}</td>
					<td>{{address.addressZip}}</td>
					<td>{{address.companyName}}</td>
					<td>{{address.companyVat}}</td>
					<td class="text-right">
						<template v-if="address.defaultAddress">
							<div class="text-success mr-5">
								<i class="fa-regular fa-circle-check"></i>
								Default
							</div>
						</template>
						<template v-if="!address.defaultAddress">
							<button
								class="btn btn-secondary"
								@click="makeDefault(address.id)"
							>
								<span
									v-if="loadingDefault[address.id]"
									class="spinner-border spinner-border-sm"
									role="status"
									aria-hidden="true"
								></span>
								Make default
							</button>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<Spinner v-if="loading" />
		<ErrorAlert :error="errMsg" v-if="errMsg && !loading" />
		<ErrorDialog ref="errDialog" />
		<AddressAddDialog ref="addressAddDialog" @addressadded="getAddresses"/>
	</div>
</template>

<script>
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import ErrorDialog from "../shared/ErrorDialog";
import CardService from "../../services/card";
import AddressAddDialog from "./AddressAddDialog";

export default {
	name: "AddressList",
	components: {
		Spinner,
		ErrorAlert,
		ErrorDialog,
		AddressAddDialog
	},
	data() {
		return {
			loading: false,
			errMsg: null,
			addresses: [],
			loadingDefault: {}
		};
	},
	mounted() {
		this.getAddresses();
	},
	methods: {
		getAddresses() {
			this.loading = true;
			CardService.instance()
				.getAddressesList()
				.then((res) => {
					this.addresses = res.data;
					this.errMsg = null;
					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					this.errMsg = err;
				});
		},
		addAddress() {
			this.$refs.addressAddDialog.show();
		},
		makeDefault(id) {
			this.$set(this.loadingDefault, id, true);
			CardService.instance()
				.makeDefaultAddress(id)
				.then(() => {
					this.loadingDefault[id] = false;
					this.getAddresses();
				})
				.catch((err) => {
					this.loadingDefault[id] = false;
					this.$refs.errDialog.show(err);
				});
		},
	},
};
</script>

<style>
</style>